exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-creator .list-creator__header {\n  width: 7em;\n  padding: 0.2rem;\n  text-align: center; }\n  .list-creator .list-creator__header label {\n    margin: 0; }\n\n.list-creator .list-creator__insert {\n  white-space: nowrap; }\n\n.list-creator .list-creator__input {\n  width: 7em; }\n\n.list-creator .list-creator__list {\n  width: 7em; }\n", ""]);

// exports
